import { registerComponent } from "helpers";
import StoreHours from "store-hours";

registerComponent(
  "store-status-hours",
  class StoreStatusHours extends StoreHours {
    constructor() {
      super();

      if (!this.config.opening_hours) {
        return;
      }

      this.innerHTML = this.isOpen
        ? this.openUntilHTML()
        : this.closedUntilHTML();
    }

    openUntilHTML() {
      return `
        <p class="no-margin">
          <span class="store-status-hours__text--open paragraph-bold">${this.config.t.openUntil} </span>
          ${this.nextClosingTime}${this.special_hours ? ` (${this.special_hours})` : ""}
        </p>
      `;
    }

    closedUntilHTML() {
      if (!this.nextOpening) {
        return `
          <p class="no-margin">
            <span class="store-status-hours__text--closed paragraph-bold">${this.config.t.closed}</span>
          </p>
        `;
      }

      return `
        <p class="no-margin">
          <span class="store-status-hours__text--closed paragraph-bold">
            ${this.config.t.closedUntil} ${this.nextOpeningDay}, ${this.nextOpeningTime}${this.special_hours ? ` (${this.special_hours})` : ""}
          </span>
        </p>
      `;
    }
  },
);
